import styled from 'styled-components';

export const H3 = styled.h3`
  margin: 0 0 24px 0;
  padding: 0 15px;
  font-size: 22px;
  ${(p) => p.theme.ProximaNovaBold};
  color: ${(p) => p.theme.darkGray};
`;
